import React, {useEffect} from "react";
import axios from "axios";
import {useFieldArray} from "react-hook-form";
import TextInput from "../../../Components/Inputs/TextInput";
import AddItemButton from "../../../Components/Buttons/AddItemButton";
import ReactSelectAsync from "../../../Components/Inputs/ReactSelectAsync";

export default function ({control, errors, register, watch, data, setData}) {
  const {fields, append, remove} = useFieldArray({
    control,
    name: "products",
    keyName: "index",
  });

  useEffect(() => {
    if (watch('products')) {
      let productIds = watch('products').map((item) => {
        return item.product_id
      })
      searchProducts(productIds, null, true)
    }
  }, [JSON.stringify(watch(['products']))])

  const searchProducts = (productIds, keyword, updateProducts = false) => {
    return axios.get('search-products-list',
      {
        params: {
          product_ids: productIds.filter(Number),
          categories: watch('categories'),
          only_discounted: watch('only_discounted') ? 1 : 0,
          keyword: keyword
        }
      }).then(res => {
      if (res.data.status === 'success') {
        if (updateProducts) {
          setData({...data, products: res.data.products})
        }
        return filterProducts(null, res.data.products);
      }
    });
  }

  const filterProducts = (selectedProductId, products) => {
    return products.filter(item => {
      let selectedProductIds = watch('products').map((item) => {
        if (selectedProductId !== item.product_id) {
          return item.product_id
        }
      })

      return (item.id !== selectedProductIds.find(id => item.id === id))
    });
  }

  return (
    <div className="card card-flush py-4 mt-3">
      <div className="card-header">
        <div className="card-title">
          <h2>Products</h2>
        </div>
        {errors?.products && (
          <div className="fv-plugins-message-container invalid-feedback mb-5">
            <div>{errors.products}</div>
          </div>
        )}
      </div>

      <div className="card-body pt-0">
        <div className="fv-row">
          {fields.map((item, index) => {
            return <div key={item.index}>
              <div className="card border-primary py-4 mt-3 mb-5">

                <div className="card-body pt-0">
                  <div className="row">
                    <div className='w-50'>
                      <ReactSelectAsync
                        label="Product"
                        name={`products.${index}.product_id`}
                        placeholder="Choose Products"
                        options={filterProducts(watch(`products.${index}.product_id`), data.products)}
                        errorMessage={errors?.[`products.${index}.product_id`]}
                        control={control}
                        search={(val) => searchProducts([watch(`products.${index}.product_id`)], val)}
                      />
                    </div>

                    <div className='w-50'>
                      <TextInput
                        label='Quantity'
                        name={`products.${index}.quantity`}
                        register={register}
                        errorMessage={errors?.[`products.${index}.Quantity`]}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className='w-50'>
                      <TextInput
                        label='Price'
                        name={`products.${index}.price`}
                        register={register}
                        errorMessage={errors?.[`products.${index}.price`]}
                      />
                    </div>

                    <div className='w-50'>
                      <TextInput
                        label='Dealing Price'
                        name={`products.${index}.dealing_price`}
                        register={register}
                        errorMessage={errors?.[`products.${index}.dealing_price`]}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="btn btn-danger btn-hover-scale btn-size"
                  >
                    -
                  </button>
                </div>
              </div>
            </div>
          })}

          <AddItemButton title='Add' onClick={() => append({
            product_id: null, quantity: null, price: null, dealing_price: null
          })}/>
        </div>
      </div>
    </div>
  );
}